import { render, staticRenderFns } from "./PointMapper.vue?vue&type=template&id=480378b3&scoped=true&"
import script from "./PointMapper.vue?vue&type=script&lang=js&"
export * from "./PointMapper.vue?vue&type=script&lang=js&"
import style0 from "./PointMapper.vue?vue&type=style&index=0&id=480378b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480378b3",
  null
  
)

export default component.exports